import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BASE_URL from '../../config';

const initialState = {
  detailTutorials: null,
  status: 'idle',
  error: null,
};

export const fetchDetailTutorials = createAsyncThunk(
  'detailTutorials/fetchDetailTutorials',
  async ({ slug, previewToken }, { rejectWithValue }) => {
    try {
      const url = previewToken
        ? `${BASE_URL}/v1/tutorials/${slug}/?preview=${previewToken}`
        : `${BASE_URL}/v1/tutorials/${slug}/`;
      const response = await fetch(url, {
        method: 'GET',
        // mode: 'no-cors',
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        return rejectWithValue(errorDetails);
      }

      return response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const detailTutorialSlice = createSlice({
  name: 'detailTutorials',
  initialState,
  reducers: {
    clearDetailTutorial: (state) => {
      state.detailTutorials = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDetailTutorials.pending, (state) => {
        state.status = 'loading';
        state.error = null;
        // Не сбрасываем данные при повторной загрузке
      })
      .addCase(fetchDetailTutorials.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.detailTutorials = action.payload; // Исправлено: detailTutorials, а не tutorials
      })
      .addCase(fetchDetailTutorials.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearDetailTutorial } = detailTutorialSlice.actions;
export default detailTutorialSlice.reducer;